import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MarkdownEditorComponent } from './markdown-editor.component';

/**
 * Markdown editor shared by every Conductor field that publishes Markdown to
 * picaluna-v3 (blog bodies, charity descriptions). Its own module so a feature
 * module can pull in the editor without the content modals coming with it.
 */
@NgModule({
  declarations: [MarkdownEditorComponent],
  imports: [CommonModule],
  exports: [MarkdownEditorComponent],
})
export class MarkdownEditorModule {}
